import React from 'react';
import x_close from '../custom_icons/mdi_close.svg'
import close_delete from '../custom_icons/close_delete.svg'
import pic_email from '../custom_icons/pic_email.svg'
import './dialogs.css'
import { getLocalizedStrings } from '../utils_android/LocalizedStrings';
import { getRequestParams, getRequestUrl } from '../utils_android/CookieHelper';
import { getHttpParams } from '../analyze_review/utils/Utils';
var strings = getLocalizedStrings()
class DeleteEmployersDialog extends React.Component {
    constructor(props){
        super(props)

    }
    onDelete = () => {
        var params = getRequestParams()
        params.order_id = this.props.order_id
        fetch(getRequestUrl() + "clearOrderEmployers", getHttpParams(params)).then((response) => response.json())
        .then((responseData) => {
           console.log("clearOrderEmployers responseData = ", responseData)
        })
        this.props.onCanceledDelete()
    }
    render(){
      
            return (
                <div className="error_bg">
                    <div style={{width : '340px', padding : '24px'}} className="error_banner_container">
                        <img style={{right : '22px'}} className="dialog-close" onClick={this.props.onCanceledDelete} src={close_delete} alt=""/>   
                        <p className="delete_order_title">{strings.deleteOrderEmplTitle}</p>  
                        <p className="delete_order_text">{strings.deleteOrderEmpl}</p>  
                        <div className="dialog_btns">
                            <p onClick={this.props.onCanceledDelete} className="error_btn color_cancel">{strings.cancel}</p>
                            <p onClick={this.onDelete} className="btn_red">{strings.deleteOrderBtn}</p>
                        </div>
                    </div>  
                </div>
            ); 
        
        
    }
}
export default DeleteEmployersDialog;